import IlaSectionCard from '@app-ila/components/Card/IlaSectionCard';
import SectionTitle from '@app-ila/components/Text/SectionTitle';
import { Box, Flex } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const GenWhatCanYou = ({ sectionContent }) => {
  return (
    <Box
      maxW={{
        base: '100%',
        sm: '540px',
        md: '720px',
        lg: '960px',
        xl: '1177px',
      }}
      mx="auto"
      w="100%"
      py={{ base: '30px', md: '0', xl: '100px' }}
    >
      <Box
        pr={{ base: '12px', md: '0' }}
        pl={{ base: '20px', md: '30px' }}
        // mt={{ base: '40px', lg: '80px' }}
        pb={'20px'}
        maxW="600px"
      >
        <SectionTitle titleObj={sectionContent[0]} />
      </Box>
      <Box
        pr={{ base: '12px', md: '0' }}
        pl={{ base: '20px', md: '30px' }}
        pb={{ base: '20px', md: '30px', xl: '50px' }}
        color={"#C1C3DD"}
        lineHeight={"28.5px"}
        maxW="1024px"
        fontSize={"18px"}
      >
        {sectionContent[1].text}
      </Box>
      <Flex
        px={{ base: '20px', md: '0' }}
        flexWrap="wrap"
        //justifyContent="space-between"
        maxW={{ base: '100%', md: '100%', xl: '100%' }}
        //mx="auto"
        // alignItems="center"
      >
        {sectionContent[2].cards.map((card, index) => {
          return (
            <IlaSectionCard
              w="100%"
              card={card}
              paddingRight={{ base: '0', md: '10px', lg:"30.83px" }}
              paddingBottom={{ base: '5px', md: '0' }}
              paddingTop={{base:"20px",sm:"20px", md:"0px", lg:"0px"}}
              borderRight={{
                base: 'none',
                md:
                  index !== sectionContent[2].cards.length - 1 &&
                  '2px dotted rgba(255, 255, 255, 0.36)',
              }}
              marginTop={{md:"40px"}}
              borderBottom={{
                base:
                index === 3 ? 'none' : '2px dotted rgba(255, 255, 255, 0.36)',
                md: 'none',
              }}

              pl={{base:"", md:"30px", sm:"", lg:""}}
            //   borderBottom={{
            //     base:
            //       index !== sectionContent[1].cards.length - 1 &&
            //       '2px dotted rgba(255, 255, 255, 0.36)',
            //     md: 'none',
            //   }}
              maxW={{ base: '100%', md: '50%', lg:"226px", xl: '280px' }}
              key={nanoid()}
              flexDir="column"
              //my={{ base: '16px', md: '60px' }}
              mergeBottom={'15px'}
              pagekey="GenA"
            />
          );
        })}
      </Flex>
    </Box>
  );
};

export default GenWhatCanYou;
